import { Button, IconStarRateFill, Text, XStack, tokens } from '@fhs/ui';
import { HapticsNotificationType, hapticNotification } from '@fhs-legacy/frontend/src/utils/haptic';
import { REWARD_AVAILABLE } from '@fhs-legacy/frontend/src/utils/test-ids';

import { IRewardAvailableProps, styles } from './typesAndStyles';

export default function RewardAvailable({ displayRewardTier, onAddReward }: IRewardAvailableProps) {
  const points = displayRewardTier.points;

  const handleAddReward = () => {
    onAddReward();
    hapticNotification({ type: HapticsNotificationType.SUCCESS });
  };

  return (
    <XStack
      testID={REWARD_AVAILABLE}
      style={styles.redeemContainer}
      accessibilityRole="text"
      accessibilityLabel={`Reward available: redeem using ${points} points`}
    >
      <Text.Ui size="sm" style={{ flex: 1 }}>
        Redeem as a Reward:
      </Text.Ui>

      <Button
        size="xs"
        type="outline"
        style={styles.pointsButton}
        onPress={handleAddReward}
        accessibilityRole="button"
        accessibilityLabel={`Redeem reward using ${points} points`}
        accessibilityHint="Applies a reward to this item, reducing its price"
      >
        <Button.Icon color={tokens.colors.$houseYellow}>
          <IconStarRateFill />
        </Button.Icon>

        {displayRewardTier.points === 0 ? (
          <Button.Text style={styles.pointsButtonText}>{displayRewardTier.name}</Button.Text>
        ) : (
          <Button.Text style={styles.pointsButtonText} data-testid={`Use ${points} Points`}>
            Use {points} Points
          </Button.Text>
        )}
      </Button>
    </XStack>
  );
}
